import { createSlice } from '@reduxjs/toolkit';
import { useTokenAuthentication } from '@src/hooks/useTokenAuthentication';
import { IKeycloakTokenResponse } from '@src/models/output/authentication/ILoginResultModel';

import { IAuthenticationReducerState } from '../states/IAuthenticationReducerState';

const tokenAuthentication = useTokenAuthentication();

const initialUser = () => {
  const item = window.localStorage.getItem('userData');
  return item ? JSON.parse(item) : {};
};

const initialAuthentication = () => {
  return tokenAuthentication.isAuthenticate();
};

export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser(),
    isAuthenticate: initialAuthentication(),
  } as IAuthenticationReducerState,
  reducers: {
    handleLogin: (state, action: { payload: IKeycloakTokenResponse }) => {
      const { access_token, refresh_token, id_token } = action.payload;
      tokenAuthentication.saveLoginToken(access_token, refresh_token, id_token);
      // Decode JWT to extract user info
      try {
        const payload = JSON.parse(atob(access_token.split('.')[1]));
        const userData = {
          firstName: payload.given_name || '',
          lastName: payload.family_name || '',
          email: payload.email || payload.preferred_username || '',
        };
        localStorage.setItem('userData', JSON.stringify(userData));
        state.userData = userData;
      } catch {
        // token decode failed, skip userData
      }
      state.isAuthenticate = true;
    },
    handleLogout: (state) => {
      tokenAuthentication.deleteLogoutToken();
      state.isAuthenticate = false;
      state.userData = undefined;
      localStorage.removeItem('userData');
    },
    reloadUserData: (state, action) => {
      var result = action.payload;
      localStorage.setItem('userData', JSON.stringify(result.data.data));
      state.userData = result.data.data;
    },
  },
});

export const { handleLogin, handleLogout, reloadUserData } = authSlice.actions;

export default authSlice.reducer;
